import {Component, Input} from '@angular/core';
import {TileType22} from "../../../models";
import {
    ControlService,
    IconService,
    ParametersService,
    SubtitlesService,
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-fan',
    templateUrl: './tile-fan.component.html',
    styleUrls: ['./tile-fan.component.scss']
})
export class TileFanComponent {
    @Input() tile: TileType22;

    constructor(
        private control: ControlService,
        public icon: IconService,
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }
}
